import { createFileRoute } from "@tanstack/react-router";
import { cn } from "cn";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { AuthRedirectProvider } from "@/features/auth/_providers/auth-redirect-provider";
import { ResetPasswordInvalid } from "@/features/auth/reset-password-invalid";

export const Route = createFileRoute("/(auth)/reset-password-invalid")({
  component: ResetPasswordInvalidPage,
});

function ResetPasswordInvalidPage() {
  return (
    <AuthRedirectProvider>
      <PublicLayout>
        <ResponsiveWrapper
          className={cn(
            /* sorted */
            "grow",
            "py-12",
            "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
          )}
        >
          <ResetPasswordInvalid />
        </ResponsiveWrapper>
      </PublicLayout>
    </AuthRedirectProvider>
  );
}
